import { render, staticRenderFns } from "./customTextarea.vue?vue&type=template&id=184be57c&scoped=true"
import script from "./customTextarea.vue?vue&type=script&lang=js"
export * from "./customTextarea.vue?vue&type=script&lang=js"
import style0 from "./customTextarea.vue?vue&type=style&index=0&id=184be57c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184be57c",
  null
  
)

export default component.exports